"use strict";

module.exports = function () {
  return JSON.stringify(this.customQueries);
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/computed/custom-q.js
// module id = 2177
// module chunks = 0